import React from 'react';
import PropTypes from 'prop-types';
import { useIntl, defineMessages } from 'react-intl';

import CCRadioButton from 'components/shared/DesignSystem/SlabTransferPortal/CCRadioButton';
import { FILTER_PHOTOS_ONLY, FILTER_VIDEOS_ONLY } from 'constants/filters';
import RadioWrap from './RadioWrap';
import GroupTitle from './GroupTitle';

const messages = defineMessages({
  title: {
    id: 'AssetFeed.ViewMenu.AssetTypeToggle.title',
    defaultMessage: 'Type',
    description: 'View menu asset type title',
  },
  labelAll: {
    id: 'AssetFeed.ViewMenu.AssetTypeToggle.labelAll',
    defaultMessage: 'All',
    description: 'Label for toggling asset type to all',
  },
  labelPhotos: {
    id: 'AssetFeed.ViewMenu.AssetTypeToggle.labelPhotos',
    defaultMessage: 'Photos Only',
    description: 'Label for toggling asset type to photos',
  },
  labelVideos: {
    id: 'AssetFeed.ViewMenu.AssetTypeToggle.labelVideos',
    defaultMessage: 'Videos Only',
    description: 'Label for toggling asset type to videos',
  },
});

const AssetTypeToggle = ({ setAssetType, selectedAssetType }) => {
  const { formatMessage } = useIntl();

  const handleChange = (assetType) => {
    setAssetType({ assetType });
  };

  return (
    <div>
      <GroupTitle>{formatMessage(messages.title)}</GroupTitle>
      <RadioWrap>
        <CCRadioButton
          id="asset-type-selector-all"
          label={formatMessage(messages.labelAll)}
          value="all"
          layout="inline"
          name="asset-type-selector"
          onChange={() => {
            handleChange(null);
          }}
          checked={
            selectedAssetType !== FILTER_PHOTOS_ONLY &&
            selectedAssetType !== FILTER_VIDEOS_ONLY
          }
          data-testid="view_menu__type-all"
        />
        <CCRadioButton
          id="asset-type-selector-photos"
          label={formatMessage(messages.labelPhotos)}
          value="photos"
          layout="inline"
          name="asset-type-selector"
          onChange={() => {
            handleChange(FILTER_PHOTOS_ONLY);
          }}
          checked={selectedAssetType === FILTER_PHOTOS_ONLY}
          data-testid="view_menu__type-photos-only"
        />
        <CCRadioButton
          id="asset-type-selector-videos"
          label={formatMessage(messages.labelVideos)}
          value="videos"
          layout="inline"
          name="asset-type-selector"
          onChange={() => {
            handleChange(FILTER_VIDEOS_ONLY);
          }}
          checked={selectedAssetType === FILTER_VIDEOS_ONLY}
          data-testid="view_menu__type-videos-only"
        />
      </RadioWrap>
    </div>
  );
};

AssetTypeToggle.propTypes = {
  setAssetType: PropTypes.func,
  selectedAssetType: PropTypes.string,
};

export default AssetTypeToggle;
